import React from 'react';
import { cn } from '../../utils/cn';
import type { IconProps } from './icons.types';
/**
 * IconCloseBottomSheet
 */
export const IconCloseBottomSheet: React.FC<IconProps> = ({ width = 50, height = 50, className }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 47 47"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(className)}
    >
        <path
            d="M23.5 41.125C27.5776 41.125 31.5291 39.7111 34.6812 37.1243C37.8332 34.5375 39.9908 30.9378 40.7863 26.9385C41.5818 22.9392 40.966 18.7878 39.0439 15.1916C37.1217 11.5955 34.012 8.77707 30.2448 7.21662C26.4776 5.65618 22.2858 5.45025 18.3837 6.63393C14.4817 7.8176 11.1108 10.3176 8.84535 13.7081C6.57994 17.0985 5.56019 21.1695 5.95987 25.2275C6.35955 29.2855 8.15392 33.0794 11.0372 35.9628"
            stroke="white"
            strokeWidth={4}
            strokeLinecap="round"
        />
        <path d="M17.625 17.625L29.375 29.375" stroke="white" strokeWidth={4} strokeLinecap="round" />
        <path d="M29.375 17.625L17.625 29.375" stroke="white" strokeWidth={4} strokeLinecap="round" />
    </svg>
);
